define.alias("shared/utils/formatters/ig-story-from-dynamo", "calendar/utils/formatters/ig-story-from-dynamo");